import React from 'react';
import { useNavigate } from 'react-router-dom';
import Popup from 'reactjs-popup';
import {HiOutlineUser} from 'react-icons/hi';
import 'reactjs-popup/dist/index.css';
import styled from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';

import './Header.css';
import CardInfoUser from '../CardInfoUser/CardInfoUser';

const StyledPopup = styled(Popup)`
  &-content {
    width: 350px !important;
    max-width: 1270px;
  }
`;

const Header = (props) => {
    const {user, logout, ticketsStateSummary, resetTicketFilters} = props
    const navigate = useNavigate();
    
    return (
        <div className = 'container-fluid' style = {{marginBottom: "10px"}}>
            <div className = 'row'>
                <div className = 'col-3 d-inline-flex flex-row'>
                    <img alt = "G2 Cloud ERP" src = "https://cdn.g2cloud.es/soporte/img/g2cloud_small.png" width = "200" height = "40" onClick = {() => {
                        
                        navigate('/soporte');
                    }}/>
                </div>
                <div className = 'col d-inline-flex justify-content-center'></div>
                <div className = 'col-4 d-inline-flex flex-row-reverse'>
                    <div style = {{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <div className = 'd-inline-flex flex-row' style = {{marginRight: "10px", marginTop: "6px"}}>
                            <span className = 'badge text-bg-danger' style = {{marginRight: "5px"}}>{ticketsStateSummary.pending}</span>
                            <span className = 'badge text-bg-warning'>{ticketsStateSummary.process}</span>
                        </div>
                        <div className = 'd-inline-flex flex-row-reverse'>
                            <StyledPopup
                                trigger = {
                                    <div className = 'hoverDiv' style = {{cursor: "pointer", fontSize: "15px"}}>
                                        <span>{`Hola, `}</span>
                                        <span style = {{fontWeight: 500}}>{`${user.name}`}</span>
                                        <span style = {{marginRight: "10px"}}>{` (${user.installation})`}</span>
                                        <span style={{fontSize: "20px"}}><HiOutlineUser style={{marginBottom: "3px"}} /></span>
                                    </div>
                                }
                                position = "bottom center"
                                nested
                                arrow = {false}
                            >
                                <div style={{margin: "8px 3px"}}>
                                    {<CardInfoUser user = {user} logout = {logout} ticketsStateSummary = {ticketsStateSummary}/>}
                                </div>
                            </StyledPopup>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;
